module.exports = __webpack_public_path__ + "img/productRobot_22.ab2df139.png";